/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerfollowqrcopy3Inputs */

const en_organizerfollowqrcopy3 = /** @type {(inputs: Organizerfollowqrcopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

const de_organizerfollowqrcopy3 = /** @type {(inputs: Organizerfollowqrcopy3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link kopieren`)
};

/**
* | output |
* | --- |
* | "Copy link" |
*
* @param {Organizerfollowqrcopy3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerfollowqrcopy3 = /** @type {((inputs?: Organizerfollowqrcopy3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerfollowqrcopy3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerfollowqrcopy3(inputs)
	return de_organizerfollowqrcopy3(inputs)
});
export { organizerfollowqrcopy3 as "organizerFollowQrCopy" }